import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Adjustment } from '../../model/project/adjustment';
import Employee from '../../model/product/employee';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import { RequestService } from '../../services/request.service';
import ProjectHelper from 'src/app/helpers/project-helper';
import BrowserHelper from 'src/app/helpers/browser-helper';
import Quotation from 'src/app/model/quotation';
import DateHelper from 'src/app/helpers/date-helper';
import UserHelper from 'src/app/helpers/user-helper';
import { Project } from 'src/app/model/project/project';
import { StringHelper } from 'src/app/helpers/string-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import * as moment from 'moment-timezone';
import ProjectInvoice from 'src/app/model/invoice/project-invoice';
import { HEIGHT_EQUIPMENT_OPTIONS } from 'src/app/model/product/product';
import InvoiceHelper from 'src/app/helpers/invoice-helper';
import { ModalService } from 'src/app/services/modal.service';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { SendQuotationMailComponent } from 'src/app/modals/send-quotation-mail/send-quotation-mail.component';
import RegisteredAction from 'src/app/model/registered-action';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import LoggedAction from 'src/app/model/logged-action';
import { AuthService } from 'src/app/services/auth.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SnackService } from 'src/app/services/snack.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'in-edit-adjustment',
  templateUrl: './in-edit-adjustment.component.html',
  styleUrls: ['./in-edit-adjustment.component.scss'],
})
export class InEditAdjustmentComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  public designerChoices: Employee[] = [];
  public printworkHandlerChoices: Employee[] = [];
  public quotationHandlerChoices: Employee[] = [];
  public finisherChoices: Employee[] = [];
  public placerChoices: Employee[] = [];
  public externalSupplierEmployeeChoices: Employee[] = [];

  @ViewChild('confirmedPlacementDateInput')
  confirmedPlacementDateInput: ElementRef<HTMLInputElement>;

  @Input()
  project: Project;

  @Input()
  subproject: Adjustment;

  @Output()
  output = new EventEmitter();

  quotationIsCollapsed = true;
  designIsCollapsed = true;
  printworkIsCollapsed = true;
  finishIsCollapsed = true;
  placementIsCollapsed = true;
  invoicingIsCollapsed = true;
  safari: boolean;

  hours = GeneralHelper.hours;
  minutes = GeneralHelper.minutes;
  heightEquipmentOptions = HEIGHT_EQUIPMENT_OPTIONS;

  totalExecutionTime: string;
  displayTotalExecutionTime: boolean = false;

  private dialogRef: MatDialogRef<SendQuotationMailComponent>;
  invoiceSent = new Subject<any>();

  constructor(
    private requestService: RequestService,
    private authService: AuthService,
    private modalService: ModalService,
    private snackService: SnackService,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit() {
    this.safari = BrowserHelper.isSafari();
    if (this.subproject.quotation == null) {
      this.subproject.quotation = new Quotation();
    }
    this.calculateTotalExecutionTime();
    this.getDesigners();
    this.getPrintworkHandlers();
    this.getFinishers();
    this.getPlacers();
    this.getQuotationHandlers();
    this.getExternalSupplierEmployees();
  }

  ngOnDestroy(): void {
    this.invoiceSent.complete();
  }

  calculateTotalExecutionTime() {
    this.totalExecutionTime = GeneralHelper.getMinutesInHourAndMinutes(
      ProjectHelper.getTotalProjectExecutionMinutes(
        this.subproject.projectPlacement
      )
    );
    this.displayTotalExecutionTime =
      this.subproject.projectPlacement != null &&
      this.subproject.projectPlacement.placementDone === true;
  }

  save() {
    this.output.emit(this.subproject);
  }

  setImportantQuotation() {
    if (this.subproject.quotationImportant != null) {
      this.subproject.quotationImportant = !this.subproject.quotationImportant;
    } else {
      this.subproject.quotationImportant = true;
    }
    this.save();
  }

  needsQuotation(event) {
    this.subproject.needsQuotation = event;
    if (event) {
      this.quotationIsCollapsed = false;
    }
    this.save();
  }

  needsQuotationText(event) {
    this.subproject.quotationComments = event;
    this.save();
  }

  quotationHandlerChange() {
    this.save();
  }

  quotationByDateChange() {
    this.save();
  }

  setQuotationComments(value) {
    this.subproject.quotationComments = value;
    this.save();
  }

  setExtraInfoInvoice(value) {
    this.subproject.extraInfoInvoice = value;
    this.save();
  }

  setQuotationApproved(value) {
    this.subproject.quotation.approved = value;
    this.save();
  }

  setQuotationApprovalReasons(value) {
    this.subproject.quotation.approvalReasons = value;
    this.save();
  }

  setNoteForCustomer(value) {
    this.subproject.quotation.noteForCustomer = value;
    this.save();
  }

  setQuotationSent(value) {
    this.subproject.quotationSent = value;
    this.save();
  }

  setQuotationFollowed(value) {
    this.subproject.quotationFollowed = value;
    this.save();
  }

  pendingChange(value) {
    this.subproject.pending = value;
    this.save();
  }

  needsDesign(event) {
    this.subproject.needsDesign = event;
    if (event === 'yes') {
      delete this.subproject.extraInfoDesign;
    }
    if (event) {
      this.designIsCollapsed = false;
    }
    this.save();
  }

  needsDesignText(event) {
    this.subproject.extraInfoDesign = event;
    this.save();
  }

  designerChange(event) {
    this.save();
  }

  compareEntities(o1, o2) {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      if (o1.id === o2.id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  compareEnums(o1: any, o2: any): boolean {
    return GeneralHelper.compareNameEnum(o1, o2);
  }

  getQuotationHandlers() {
    this.addSubscription(
      this.requestService.get('/employees/withType/QUOTATION'),
      (result) => {
        this.quotationHandlerChoices = <Employee[]>result.body;
      }
    );
  }

  getDesigners() {
    this.addSubscription(
      this.requestService.get('/employees/withType/DESIGNER'),
      (result) => {
        this.designerChoices = <Employee[]>result.body;
      }
    );
  }

  getPrintworkHandlers() {
    this.addSubscription(
      this.requestService.get('/employees/withType/PRINTER'),
      (result) => {
        this.printworkHandlerChoices = <Employee[]>result.body;
      }
    );
  }

  getFinishers() {
    this.addSubscription(
      this.requestService.get('/employees/withType/FINISHER'),
      (result) => {
        this.finisherChoices = <Employee[]>result.body;
      }
    );
  }

  getPlacers() {
    this.addSubscription(
      this.requestService.get('/employees/withType/PLACER'),
      (result) => {
        this.placerChoices = <Employee[]>result.body;
      }
    );
  }

  getExternalSupplierEmployees() {
    this.addSubscription(
      this.requestService.get('/employees/withType/EXTERNAL_SUPPLIER'),
      (result) => {
        this.externalSupplierEmployeeChoices = <Employee[]>result.body;
      }
    );
  }

  designByDate(event) {
    this.save();
  }

  setAdjustmentMaterial(value) {
    this.subproject.material = value;
    this.save();
  }

  setAdjustmentSize(value) {
    this.subproject.size = value;
    this.save();
  }

  amountDesignChange() {
    this.save();
  }

  setDesignHours() {
    this.save();
  }

  setDesignMinutes() {
    this.save();
  }

  inpressLogoChanged(value: boolean) {
    this.subproject.inpressLogo = value;
    this.save();
  }

  immoscoopLogoChanged(value: boolean) {
    this.subproject.immoscoopLogo = value;
    this.save();
  }

  spottoLogoChanged(value: boolean) {
    this.subproject.spottoLogo = value;
    this.save();
  }

  spellCheck(value: boolean) {
    this.subproject.spellCheck = value;
    this.save();
  }

  designFollowUpChange(value) {
    this.subproject.designFollowUp = value;
    this.save();
  }

  designSentToCustomerChange(event) {
    this.subproject.designSentToCustomer = event;
    this.save();
  }

  printByChange(event) {
    this.subproject.printByMutoh = event[0];
    this.subproject.printByAgfa = event[1];
    this.save();
  }

  designApproved(event) {
    this.subproject.designApproved = event;
    this.save();
  }

  printWork(event) {
    this.subproject.needPrintwork = event;
    if (event === 'yes') {
      delete this.subproject.printworkExtraInfo;
    }
    if (event) {
      this.printworkIsCollapsed = false;
    }
    this.save();
  }

  printworkHandlerChange() {
    this.save();
  }

  printworkFollowUpChange(value) {
    this.subproject.printworkFollowUp = value;
    this.save();
  }

  printworkExtraInfoChange(value) {
    this.subproject.printworkExtraInfo = value;
    this.save();
  }

  printworkReady(event) {
    this.subproject.printWorkReady = event;
    this.save();
  }

  finish(event) {
    this.subproject.needFinish = event;
    if (event === 'yes') {
      delete this.subproject.finishDescription;
    }
    if (event) {
      this.finishIsCollapsed = false;
    }
    this.save();
  }

  finishDescriptionChange(value) {
    this.subproject.finishDescription = value;
    this.save();
  }

  finishFollowUpChange(value) {
    this.subproject.finishFollowUp = value;
    this.save();
  }

  finishReady(event) {
    this.subproject.finishReady = event;
    this.save();
  }

  finisherChange(event) {
    this.save();
  }

  designFinishedChange($event: boolean) {
    this.subproject.designFinished = $event;
    this.save();
  }

  doLocationVerificationChange(value: boolean) {
    this.subproject.projectPlacement.doLocationVerification = value;
    this.save();
  }

  locationVerificationCheckedByExpertChange(value: boolean) {
    this.subproject.projectPlacement.locationVerificationCheckedByExpert =
      value;
    this.save();
  }

  locationVerificationExtraInfoChange(value: string) {
    this.subproject.projectPlacement.locationVerificationExtraInfo = value;
    this.save();
  }

  locationVerifiedChange(value: boolean) {
    this.subproject.projectPlacement.locationVerified = value;
    this.save();
  }
  withPlacementChange(value) {
    this.subproject.withPlacement = value;
    if (value === false) {
      this.subproject.currentConfirmedPlacementDate = null;
    }
    if (value) {
      this.placementIsCollapsed = false;
    }
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save();
  }

  withPlacementNotesChange(value) {
    this.subproject.withPlacementNotes = value;
    this.save();
  }

  pickupReadyChange(value) {
    this.subproject.pickup.ready = value;
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save();
  }

  placerChange(event) {
    this.save();
  }

  setHours() {
    this.save();
  }

  setMinutes() {
    this.save();
  }

  extraHoogwerkerChange(event) {
    this.subproject.extraHoogwerker = event;
    this.save();
  }

  extraHoogwerkerTextChange(event) {
    this.subproject.extraHoogwerkerDescription = event;
    this.save();
  }

  extraHoogwerkerDoneChange(event) {
    this.subproject.extraHoogwerkerDone = event;
    this.save();
  }

  extraHoogwerkerEmployeeChange() {
    this.save();
  }

  extraHoogwerkerDeadlineChange(event) {
    this.subproject.extraHoogwerkerDeadline = event.value;
    this.save();
  }

  parkingBanChange(value) {
    this.subproject.parkingBan = value;
    this.save();
  }

  extraInfoParkingBanChange(value) {
    this.subproject.extraInfoParkingBan = value;
    this.save();
  }

  parkingBanDoneChange(value) {
    this.subproject.parkingBanDone = value;
    this.save();
  }

  parkingBanEmployeeChange() {
    this.save();
  }

  parkingBanDeadlineChange(event) {
    this.subproject.parkingBanDeadline = event.value;
    this.save();
  }

  needExtraSupplierChange(value) {
    this.subproject.needExtraSupplier = value;
    this.save();
  }

  needExtraSupplierDoneChange(value) {
    this.subproject.needExtraSupplierDone = value;
    this.save();
  }

  extraInfoNeedExtraSupplierChange(value) {
    this.subproject.extraInfoNeedExtraSupplier = value;
    this.save();
  }

  extraSupplierEmployeeChange() {
    this.save();
  }

  extraSupplierDeadlineChange(event) {
    this.subproject.extraSupplierDeadline = event.value;
    this.save();
  }

  needExtraMaterialsChange(value) {
    this.subproject.needExtraMaterials = value;
    this.save();
  }

  needExtraMaterialsDoneChange(value) {
    this.subproject.needExtraMaterialsDone = value;
    this.save();
  }

  extraInfoNeedExtraMaterialsChange(value) {
    this.subproject.extraInfoNeedExtraMaterials = value;
    this.save();
  }

  extraMaterialsEmployeeChange() {
    this.save();
  }

  extraMaterialsDeadlineChange(event) {
    this.subproject.extraMaterialsDeadline = event.value;
    this.save();
  }

  placementDoneChange(event) {
    this.subproject.projectPlacement.placementDone = event;
    if (event) {
      this.subproject.currentExecutionDate = moment
        .tz('Europe/Brussels')
        .toDate();
      this.subproject.projectPlacement.placementDoneRegistration =
        new LoggedAction();
      this.subproject.projectPlacement.placementDoneRegistration.date =
        new Date();
      this.subproject.projectPlacement.placementDoneRegistration.by =
        this.authService.getAuthenticatedUser();
    } else {
      this.subproject.projectPlacement.placementDoneRegistration = null;
    }
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save();
  }

  placementDoneExtraInfoChange(event) {
    this.subproject.projectPlacement.placementDoneExtraInfo = event;
    this.save();
  }

  placerFeedbackChange(event) {
    this.subproject.projectPlacement.placerFeedback = event;
    this.save();
  }

  currentConfirmedPlacementDateChange(event) {
    let newDate = event.value;
    if (
      this.subproject.projectPlacement.placementEarliestDate != null &&
      moment
        .tz(newDate, 'Europe/Brussels')
        .isBefore(
          moment.tz(
            this.subproject.projectPlacement.placementEarliestDate,
            'Europe/Brussels'
          ),
          'day'
        )
    ) {
      this.modalService.confirmDialog(
        'Datum vroeger dan gevraagde datum',
        'De geselecteerde datum (' +
          DateHelper.formatDate(newDate) +
          ') is vroeger dan de gevraagde datum (' +
          DateHelper.formatDate(
            this.subproject.projectPlacement.placementEarliestDate
          ) +
          '). Bent u zeker dat u deze datum wilt selecteren?',
        (c) => {
          if (c) {
            this.subproject.currentConfirmedPlacementDate = newDate;
            this.save();
          } else {
            this.confirmedPlacementDateInput.nativeElement.value =
              DateHelper.formatDate(
                this.subproject.currentConfirmedPlacementDate
              );
          }
        }
      );
    } else {
      this.subproject.currentConfirmedPlacementDate = newDate;
      this.save();
    }
  }

  currentPlacementDateConfirmedChange(value) {
    this.subproject.projectPlacement.currentPlacementDateConfirmed = value;
    this.save();
  }

  placeInstructionsChanged(value: string) {
    this.subproject.projectPlacement.placeInstructions = value;
    this.save();
  }

  soldRentedStickerWorkHeightChange(value: number) {
    this.subproject.projectPlacement.soldRentedStickerWorkHeight = value;
    this.save();
  }

  heightEquipmentChange() {
    this.save();
  }

  obstaclesPresentChange(value: boolean) {
    this.subproject.projectPlacement.obstaclesPresent = value;
    this.save();
  }

  obstaclesInfoTextChange(value: string) {
    this.subproject.projectPlacement.obstaclesInfo = value;
    this.save();
  }

  needsInvoiceChange(event) {
    if (event) {
      this.invoicingIsCollapsed = false;
    }
    this.subproject.needsInvoice = event;
    this.save();
  }

  invoiceNotesChange(event) {
    this.subproject.invoiceNotes = event;
    this.save();
  }

  atLeastOneInvoiceSent() {
    return (
      this.subproject.projectInvoices != null &&
      this.subproject.projectInvoices.length > 0 &&
      this.subproject.projectInvoices.some((pi) => pi.teamleaderId != null)
    );
  }

  getFirstSentInvoice() {
    if (
      this.subproject.projectInvoices == null ||
      this.subproject.projectInvoices.length === 0
    ) {
      return null;
    }
    return this.subproject.projectInvoices.find(
      (pi) => pi.teamleaderId != null
    );
  }

  getFormDisplayNameUpperCase() {
    return ProjectHelper.getFormDisplayNameUpperCase(this.subproject);
  }
  getFormDisplayNameLowerCase() {
    return ProjectHelper.getFormDisplayNameLowerCase(this.subproject);
  }

  formatDate(date) {
    return DateHelper.formatDate(date);
  }

  getLetters(employee: Employee) {
    return UserHelper.getLettres(employee.user);
  }

  getName(employee: Employee) {
    return UserHelper.getName(employee.user);
  }

  getBaseProject() {
    return ProjectHelper.getBaseProject(this.project);
  }

  getBaseProjectExtraInfoPlacement() {
    let baseProject = ProjectHelper.getBaseProject(this.project);
    if (baseProject != null && baseProject.projectPlacement != null) {
      return baseProject.projectPlacement.extraPlacementInfo;
    }
    return '';
  }

  getBaseProjectPlacementFloor() {
    let baseProject = ProjectHelper.getBaseProject(this.project);
    if (baseProject != null && baseProject.projectPlacement != null) {
      return StringHelper.isEmpty(baseProject.projectPlacement.placementFloor)
        ? 'Geen informatie beschikbaar'
        : baseProject.projectPlacement.placementFloor;
    }
    return 'Geen informatie beschikbaar';
  }

  getBaseProjectHeightEquipment() {
    if (this.project.products == null || this.project.products.length === 0) {
      return 'Geen informatie beschikbaar';
    }
    if (this.project.products.length === 1) {
      let productPlacement = this.project.products[0].productPlacement;
      return productPlacement == null ||
        productPlacement.heightEquipment == null
        ? 'Geen informatie beschikbaar'
        : productPlacement.heightEquipment.name;
    }
    let toReturn = '';
    for (let i = 0; i < this.project.products.length; i++) {
      let product = this.project.products[i];
      if (
        product.productPlacement == null ||
        product.productPlacement.heightEquipment == null
      ) {
        continue;
      }
      let toAppend =
        ProductHelper.getType(product.type) +
        ' #' +
        (i + 1) +
        ': ' +
        product.productPlacement.heightEquipment.name;
      toReturn += toReturn === '' ? toAppend : '\n' + toAppend;
    }
    return toReturn === '' ? 'Geen informatie beschikbaar' : toReturn;
  }

  getLinkText(invoice: ProjectInvoice) {
    return InvoiceHelper.getLinkText(invoice);
  }

  displayDesignMaterial() {
    return StringHelper.isEmpty(this.subproject.material)
      ? 'Geen informatie beschikbaar'
      : this.subproject.material;
  }

  displayDesignSize() {
    return StringHelper.isEmpty(this.subproject.size)
      ? 'Geen informatie beschikbaar'
      : this.subproject.size;
  }

  displayAmountDesign() {
    return this.subproject.amountDesign == null
      ? 'Geen informatie beschikbaar'
      : this.subproject.amountDesign;
  }

  getSendQuotationLabel(): string {
    return this.subproject.quotationSent
      ? 'Offerte opnieuw versturen'
      : 'Offerte versturen';
  }

  openSendQuotationModal() {
    let config = {
      project: this.project,
      subProject: this.subproject,
    };
    this.dialogRef = this.dialog.open(SendQuotationMailComponent, {
      data: config,
    });
    this.addSubscription(
      this.dialogRef.afterClosed(),
      (registeredAction: RegisteredAction) => {
        if (registeredAction != null) {
          if (this.subproject.quotation.registeredActions == null) {
            this.subproject.quotation.registeredActions = [registeredAction];
          } else {
            this.subproject.quotation.registeredActions.unshift(
              registeredAction
            );
          }
          this.subproject.quotationSent = true;
        }
      }
    );
  }

  trackBy(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }

  compareNumbers(n1, n2) {
    return n1 == n2;
  }

  designFinishedVerification(): boolean {
    if (!this.subproject.designSentToCustomer) {
      this.snackService.showError('Ontwerp is nog niet verstuurd naar klant');
      return false;
    }
    if (!this.subproject.designApproved) {
      this.snackService.showError('Ontwerp is nog niet goedgekeurd door klant');
      return false;
    }
    return true;
  }

  designFinishedVerificationCallback =
    this.designFinishedVerification.bind(this);
}
